import { httpSkynetApi } from 'app/services/http';

import { CONFLICT_TYPE } from 'constants/http';
import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

// General Loan Application API interceptor. Any extra logic should be added consciously
export const useLoanApplicationApiInterceptor = () => {
  useEffectSafeStrictMode(() => {
    const onSuccessResponse = response => {
      const isInvalidProgram = response?.data?.type === CONFLICT_TYPE.INVALID_LOAN_PROGRAM;
      const isRejectResponse = isInvalidProgram;

      if (isRejectResponse) {
        return Promise.reject({ response });
      }

      return response;
    };

    const interceptor = httpSkynetApi.injectResponseInterceptor(onSuccessResponse);

    return () => httpSkynetApi.ejectResponseInterceptor(interceptor);
  }, []);
};
